module.exports = Object.freeze({
    Office: { value: 1, name: 'Fortude Office' },
    WFH: { value: 2, name: 'Work From Home' },
    ClientSite : { value: 3, name: 'Client Site' }
  });
  